import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import {MatTabsModule} from '@angular/material/tabs';
import { I18NextModule } from 'angular-i18next';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { TooltipModule } from 'ng2-tooltip-directive';
import { CallbackDisplayConfigComponent } from './callback-display-config/callback-display-config.component';
import { CallbackDisplayPageComponent } from './callback-display-page/callback-display-page.component';

@NgModule({
  declarations: [
    CallbackDisplayConfigComponent,
    CallbackDisplayPageComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    // TooltipModule,
    SharedModule,
    NgSelectModule,
    I18NextModule.forRoot()
  ],
})
export class CallbackDisplayModule { }
